export { EntryCardWrapper as EntryCard } from './EntryCard'
